export default "__VITE_ASSET__vr$ZNixY__"